import angular from 'angular';
import SignalRService from '@/shared/services/SignalRService';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('taskTemplatesCtrl', [
    '$scope',
    '$http',
    '$q',
    '$timeout',
    'appUrls',
    'resourceFactorySvc',
    '$filter',
    'flySvc',
    'dialogsSvc',
    'ModalService',
    'settingsDialogsSvc',
    'dataCache',
    'checkFeature',
    'templateHttpSvc',
    '$translate',
    'translateListFilter',
    'resourceNameFilter',
    taskTemplatesCtrl,
  ]);

function taskTemplatesCtrl(
  $scope,
  $http,
  $q,
  $timeout,
  appUrls,
  resourceFactorySvc,
  $filter,
  flySvc,
  dialogsSvc,
  ModalService,
  settingsDialogsSvc,
  dataCache,
  checkFeature,
  templateHttpSvc,
  $translate,
  translateListFilter,
  resourceNameFilter,
) {
  var vm = this;
  vm.taskTemplates = null;
  vm.resources = null;
  vm.costResources = null;
  vm.mailTemplates = null;
  vm.users = [];
  vm.uploadingSnippet = false;

  function attachResource(task) {
    task.resource = task.resourceId
      ? vm.resources.find(function(r) {
          return r.id === task.resourceId;
        })
      : null;
  }
  function attachCostResource(task) {
    task.costResource = task.costResourceId
      ? vm.costResources.find(function(r) {
          return r.id === task.costResourceId;
        })
      : null;
  }

  function attachMailTemplate(task) {
    task.mailTemplate = task.mailTemplateId
      ? vm.mailTemplates.find(t => t.id === task.mailTemplateId)
      : null;
  }

  function mapAssignedTo(task) {
    const { assignedType = 0, userId = null, profile = null } = task;
    task.assignedTo = {
      assignedType,
      userId,
      profile,
    };
  }

  function mapTask(task) {
    attachResource(task);
    attachCostResource(task);
    attachMailTemplate(task);
    mapAssignedTo(task);
    if (task.children) {
      task.children.forEach(mapTask);
      task.children = task.children.sortByProperty('priority');
    }
    return task;
  }
  $q.all([
    $http.get(appUrls.tasks + '/api/tasktemplates/templates').then(function(result) {
      vm.taskTemplates = result.data
        .map(item => ({
          ...item,
          name: $filter('translateList')(item.id, 'tasktemplate', item.name),
        }))
        .sortByProperty('name');
    }),
    resourceFactorySvc.get('resource').reg(
      {
        type: 0,
      },
      function(data) {
        vm.resources = data
          .map(item => ({
            ...item,
            label: resourceNameFilter(item),
            code: item.code || '',
          }))
          .sort(dynamicSortMultiple('code', 'label'));
      },
    ).$promise,
    resourceFactorySvc.get('resource').reg(
      {
        type: 1,
      },
      function(data) {
        vm.costResources = data
          .map(item => ({
            ...item,
            label: resourceNameFilter(item),
            code: item.code || '',
          }))
          .sort(dynamicSortMultiple('code', 'label'));
      },
    ).$promise,
    templateHttpSvc.getTemplates(11).then(function(data) {
      const label = template => translateListFilter(template.id, 'template', template.name);
      vm.mailTemplates = data;
      vm.mailTemplates.sort((a, b) => label(a).localeCompare(label(b)));
    }),
  ]).then(function() {
    vm.taskTemplates.forEach(mapTask);
    vm.taskTemplates = vm.taskTemplates.sortByProperty('name');
  });

  var updateTaskTemplate = function(task, model, field, $data) {
    return $http.put(appUrls.tasks + '/api/tasktemplates/templates', model).then(
      function(result) {
        if (result.tags === null) delete result.tags; //Don't reset tags property
        if (field === 'resource') {
          task.resourceId = $data ? $data.id : null;
          task.resource = $data;
        } else if (field === 'costResource') {
          task.costResourceId = $data ? $data.id : null;
          task.costResource = $data;
        } else {
          task[field] = $data;
        }
        if (field === 'assignedTo' && $data) {
          angular.extend(task, $data);
        }

        if (result && result.data && result.data.countPlannedTasksUpdated) {
          const count = result.data.countPlannedTasksUpdated;
          flySvc.proposal('msgPropogateTaskTemplateChangesCount', null, null, null, null, {
            count,
          });
        } else {
          flySvc.success();
        }

        return false;
      },
      function(error) {
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.updateTaskTemplates = function(task, $data, field, showPropogateDialog) {
    if (field.indexOf('appliesTo') !== 0 && angular.equals(task[field], $data)) return false; //Not changed
    var model = angular.copy(task);

    model.PropogateTemplateChanges = false;

    if (field === 'mailTemplate') {
      model.mailTemplateId = $data ? $data.id : null;
    }
    if (field === 'assignedTo' && $data) {
      angular.extend(model, $data);
    }
    if (field === 'resource') {
      model.resourceId = $data ? $data.id : null;
      delete model.resource;
    } else if (field === 'costResource') {
      model.costResourceId = $data ? $data.id : null;
      if (!model.costResourceId) {
        model.costParameterDefinitionId = null;
        model.costRegistrationUserId = null;
      }
      delete model.costResource;
    } else {
      model[field] = $data;
    }

    delete model.assignedTo;
    delete model.mailTemplate;
    delete model.tags;

    if (showPropogateDialog) {
      // Offer to reset the per-relation duration deviations only when the duration changed
      var showResetDeviations = field === 'defaultExecutionDuration';
      return dialogsSvc
        .confirmTemplateChanges(
          'msgConfirmPropogateTemplateChangesTitle',
          'msgConfirmPropogateTemplateChanges',
          showResetDeviations,
        )
        .then(
          function({ result, resetDeviations }) {
            if (result === null) return false; // Cancel changes

            model.resetDeviations = !!resetDeviations;

            if (!result) return updateTaskTemplate(task, model, field, $data);

            model.PropogateTemplateChanges = true;
            return updateTaskTemplate(task, model, field, $data);
          },
          function() {
            return false; // Cancel changes
          },
        );
    } else {
      return updateTaskTemplate(task, model, field, $data);
    }
  };

  var saving = false;
  vm.copyTaskTemplate = function(task) {
    if (saving) return;
    saving = true;
    settingsDialogsSvc
      .copyTaskTemplate(task)
      .then(function(result) {
        if (result) {
          var newTask = mapTask(result);
          newTask.isOpen = true;
          newTask.isNew = true;
          var idx = vm.taskTemplates.indexOf(task);
          if (idx >= 0) {
            vm.taskTemplates.splice(idx + 1, 0, newTask);
          } else {
            vm.taskTemplates.push(newTask);
            vm.taskTemplates = vm.taskTemplates.sortByProperty('name');
          }
        }
      })
      .finally(function() {
        saving = false;
      });
  };

  vm.addTaskTemplate = function() {
    settingsDialogsSvc.addTaskTemplate(vm.resources, vm.costResources).then(function(result) {
      if (result) {
        var newTask = mapTask(result);
        newTask.isOpen = true;
        newTask.isNew = true;
        vm.taskTemplates.push(newTask);
        vm.taskTemplates = vm.taskTemplates.sortByProperty('name');
      }
    });
  };
  vm.addSubtask = function(taskTemplate) {
    settingsDialogsSvc
      .addSubTaskTemplate(taskTemplate, vm.resources, vm.mailTemplates)
      .then(function(result) {
        if (result) {
          if (taskTemplate.children === null) taskTemplate.children = [];
          var newTask = mapTask(result);
          taskTemplate.children.push(newTask);
        }
      });
  };
  vm.deleteTaskTemplate = function(task) {
    if (!task || !task.id) return;

    return dialogsSvc
      .showYesNoCancel('msgConfirmDeleteTitle', 'msgConfirmPropagateTemplateDelete')
      .then(
        function(result) {
          if (result === null) return false; // Cancel changes

          return $http
            .delete(appUrls.tasks + '/api/tasktemplates/templates/' + task.id, {
              params: { propagate: !!result },
            })
            .then(
              function() {
                var idx = vm.taskTemplates.indexOf(task);
                if (idx >= 0) vm.taskTemplates.splice(idx, 1);
              },
              error => {
                flySvc.error(error);
              },
            );
        },
        function() {
          return false; // Cancel changes
        },
      );
  };

  function editTaskTemplate(mainTaskTemplateId, taskTemplate) {
    const { costResources, parameterDefinitions } = vm;
    ModalService.showModal({
      template: require('./dialogs/editTaskTemplateDialog.html'),
      controller: 'EditTaskTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { costResources, parameterDefinitions, mainTaskTemplateId, taskTemplate },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
        attachCostResource(taskTemplate);
      });
    });
  }

  vm.editTaskTemplate = function(taskTemplate) {
    if (!taskTemplate || !taskTemplate.id) return;
    editTaskTemplate(taskTemplate.id, taskTemplate);
  };

  vm.editSubTask = function(taskTemplate, subTaskTemplate) {
    if (!subTaskTemplate || !subTaskTemplate.id || !taskTemplate || !taskTemplate.id) return;
    editTaskTemplate(taskTemplate.id, subTaskTemplate);
  };

  vm.deleteSubTask = function(task, subtask) {
    if (!subtask || !subtask.id) return;
    return dialogsSvc
      .showYesNoCancel('msgConfirmDeleteTitle', 'msgConfirmPropagateSubtaskTemplateDelete')
      .then(
        function(result) {
          if (result === null) return false; // Cancel changes

          return $http
            .delete(appUrls.tasks + '/api/tasktemplates/templates/' + subtask.id, {
              params: { propagate: !!result },
            })
            .then(
              function() {
                var idx = task.children.indexOf(subtask);
                if (idx >= 0) task.children.splice(idx, 1);
              },
              error => {
                flySvc.error(error);
              },
            );
        },
        function() {
          return false; // Cancel changes
        },
      );
  };
  vm.updatePriority = function(task, subtask, newPriority) {
    if (!subtask || !subtask.id) return false;
    if (subtask.priority === newPriority) return false;
    return $http
      .post(`${appUrls.tasks}/api/tasktemplates/move/`, {
        id: subtask.id,
        up: false,
        priority: newPriority,
      })
      .then(({ data }) => {
        if (data && data.length) {
          data.forEach(item => {
            var t = task.children.find(x => x.id === item.id);
            if (!t) return;
            t.priority = item.priority;
          });
          task.children.sortByProperty('priority');
        }
        flySvc.success();
        return false;
      });
  };
  vm.moveSubtask = function(task, subtask, up) {
    if (!subtask || !subtask.id) return;
    $http
      .post(`${appUrls.tasks}/api/tasktemplates/move/`, {
        id: subtask.id,
        up,
      })
      .then(({ data }) => {
        if (data && data.length) {
          data.forEach(item => {
            var t = task.children.find(x => x.id === item.id);
            if (!t) return;
            t.priority = item.priority;
          });
          task.children.sortByProperty('priority');
        }
        flySvc.success();
      });
  };

  vm.openTranslation = function(task) {
    dialogsSvc
      .translateListItem('tasktemplate', task.id, task.name, { maxlength: 500 })
      .then(function(result) {
        if (result && result.defaultValue) {
          vm.updateTaskTemplates(task, result.defaultValue, 'name');
        }
      });
  };

  vm.hasMailTypes = function(task) {
    if (!task || !task.children || !task.children.length) return false;
    return task.children.some(subtask => subtask.type === 3 || subtask.type === 4);
  };

  vm.openTaskSchedules = function(task) {
    if (!task || !task.id) return;
    settingsDialogsSvc.openTaskSchedules(task.id).then(function(result) {
      if (result && typeof result.count !== 'undefined') {
        task.periodicityCount = result.count;
      }
    });
  };
  vm.openParameterDefinitions = function(task) {
    if (!task || !task.id) return;
    settingsDialogsSvc.openTaskParameterDefinitions(task.id).then(function(result) {
      if (result && typeof result.count !== 'undefined') {
        task.parameterCount = result.count;
      }
    });
  };

  vm.exportSnippet = function(task) {
    settingsDialogsSvc.exportTaskTemplateSnippet(task);
  };
  vm.uploadSnippet = function(files) {
    const [file] = files || [];
    if (!file) return;
    if (vm.uploadingSnippet) return;

    var data = new FormData();
    data.append('language', $translate.use());
    data.append('file', file.data);

    vm.uploadingSnippet = true;

    $http({
      method: 'POST',
      url: appUrls.api + '/api/Snippet/Upload/TaskTemplate',
      headers: {
        'Content-Type': undefined,
      },
      data,
    }).then(
      response => {
        if (response && response.data) {
          //open dialog
          settingsDialogsSvc.importTaskTemplateSnippet(response.data).then(function(result) {
            if (result) {
              const [taskResult, hasNewMailTemplates] = result;
              if (hasNewMailTemplates) {
                //Reload mail templates first
                return templateHttpSvc.getTemplates(11).then(function(data) {
                  vm.mailTemplates = data;
                  vm.mailTemplates.sortByProperty('name');

                  var newTask = mapTask(taskResult);
                  newTask.isOpen = true;
                  newTask.isNew = true;
                  vm.taskTemplates.push(newTask);
                  vm.taskTemplates = vm.taskTemplates.sortByProperty('name');
                  vm.uploadingSnippet = false;
                });
              }
              var newTask = mapTask(taskResult);
              newTask.isOpen = true;
              newTask.isNew = true;
              vm.taskTemplates.push(newTask);
              vm.taskTemplates = vm.taskTemplates.sortByProperty('name');
            }
          });
        }

        vm.uploadingSnippet = false;
      },
      error => {
        flySvc.error(error);
        vm.uploadingSnippet = false;
      },
    );
  };
  vm.getTagsTooltip = task => {
    if (!task) return '';
    if (!task.tags || task.tags.length === 0) return $translate.instant('EditTaskTemplateTags');
    return task.tags.map(x => x.name).join(', ');
  };
  vm.getRequiredDocumentTypesTooltip = task => {
    if (!task) return '';
    if (!task.requiredDocumentTypes || task.requiredDocumentTypes.length === 0)
      return $translate.instant('EditTaskTemplateRequiredDocumentTypes');
    return task.requiredDocumentTypes
      .map(x => $filter('translateList')(x, 'documenttype', x))
      .join(', ');
  };
  vm.openRequiredDocumentTypes = task => {
    if (!task || !task.id) return;
    settingsDialogsSvc
      .editTaskTemplateRequiredDocumentTypes(task.id, task.requiredDocumentTypes)
      .then(function(result) {
        if (result) {
          task.requiredDocumentTypes = result;
        }
      });
  };
  vm.openTags = task => {
    if (!task || !task.id) return;
    settingsDialogsSvc.editTaskTemplateTags(task.id, task.tags).then(function(result) {
      if (result) {
        task.tags = result;
      }
    });
  };

  vm.openRequiredAuthorizations = task => {
    if (!task || !task.id) return;
    settingsDialogsSvc
      .showTaskTemplateRequiredAuthorizationsDialog(
        task.id,
        task.allAuthorizationsRequired,
        task.requiredAuthorizations,
      )
      .then(function(result) {
        if (result) {
          task.requiredAuthorizations = result.requiredAuthorizations;
          task.allAuthorizationsRequired = result.allAuthorizationsRequired;
        }
      });
  };

  const emailTemplateCreatedHandler = emailTemplate => {
    if (emailTemplate.context === 11) {
      if (!vm.mailTemplates) {
        $timeout(function() {
          vm.mailTemplates = [emailTemplate];
        }, 100);
      } else {
        $timeout(function() {
          vm.mailTemplates.push(emailTemplate);
        }, 100);
      }
    }
  };

  SignalRService.subscribe('emailTemplateCreated', emailTemplateCreatedHandler);
}
